import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'
export default class extends Controller {
  static targets = ['item']
  connect() {
    useDispatch(this)
  }

  loadAttributes(event) {
    const attributesToLoad = this.data.get('attributes-as-attributes').split(' ')
    const eventSourceElement = event.target
    attributesToLoad.forEach((attribute) => {
      if (eventSourceElement.hasAttribute(attribute)) {
        this.itemTargets.forEach((item) => {
          item.setAttribute(attribute, eventSourceElement.getAttribute(attribute))
        })
      }
    })
    this.dispatch('attributesLoaded')
  }

  loadText(event) {
    const attributesToLoad = this.data.get('attributes-as-attributes').split(' ')
    const eventSourceElement = event.target
    attributesToLoad.forEach((attribute) => {
      if (eventSourceElement.hasAttribute(attribute)) {
        this.itemTargets.forEach((item) => {
          item.value = eventSourceElement.getAttribute(attribute)
        })
      }
    })
    this.dispatch('attributesLoaded')
  }

  loadInnerText(event) {
    const attributeToLoad = this.data.get('attribute-as-innertext')
    const eventSourceElement = event.target

    if (eventSourceElement.hasAttribute(attributeToLoad)) {
      const textToAdd = eventSourceElement.getAttribute(attributeToLoad)

      this.itemTargets.forEach(item => {
        item.innerText = textToAdd
      })
    }
  }
}
